import React from "react";

function RequestRecsModal({ isOpen, onClose, onConfirm, loading }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div
        className="bg-white rounded-lg shadow-lg p-6 md:p-8 w-full max-w-md mx-4 text-left"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center mb-4">
          <div className="flex-shrink-0">
            <svg
              className="w-12 h-12 text-green-500 mx-auto"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-800">Request sent to team!</h2>
        </div>
        <div className="text-gray-600">
          <p>
           Our team will review your requirements and send you an email with additional qualified candidates shortly.
          </p>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            disabled={loading}
            className="px-6 py-2 text-sm font-medium text-white bg-[#02B491] rounded-md hover:bg-[#029d7a] transition duration-200 disabled:opacity-50"
          >
            {loading ? "Processing..." : "Got it"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RequestRecsModal; 